import { ProductScreenshot } from 'components/ProductScreenshot';
import EventsInPostHogLight from "../../../../contents/images/tutorials/php-ab-tests/events-light.png";
import EventsInPostHogDark from "../../../../contents/images/tutorials/php-ab-tests/events-dark.png";
import TestSetupLight from "../../../../contents/images/tutorials/php-ab-tests/experiment-setup-light.png";
import TestSetupDark from "../../../../contents/images/tutorials/php-ab-tests/experiment-setup-dark.png";
import ResultsLight from "../../../../contents/images/tutorials/php-ab-tests/results-light.png";
import ResultsDark from "../../../../contents/images/tutorials/php-ab-tests/results-dark.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  EventsInPostHogLight,
  EventsInPostHogDark,
  TestSetupLight,
  TestSetupDark,
  ResultsLight,
  ResultsDark,
  React
};